import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from 'src/app/core/guards/auth-guard.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListVehiculeComponent } from './list-vehicule/list-vehicule.component';
import { VehiculeFormComponent } from './vehicule-form/vehicule-form.component';
import { DetailVehiculeComponent } from './detail-vehicule/detail-vehicule.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { VehiculeModalAjoutComponent } from './modal/vehicule-modal-ajout/vehicule-modal-ajout.component';
import { VehiculeModalDetailRouteComponent } from './modal/vehicule-modal-detail-route/vehicule-modal-detail-route.component';

@NgModule({
	declarations: [
		ListVehiculeComponent,
		VehiculeFormComponent,
		DetailVehiculeComponent,
		VehiculeModalAjoutComponent,
		VehiculeModalDetailRouteComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class VehiculesModule {}
